import script from "./qiyuegl-5.vue?vue&type=script&setup=true&lang=js"
export * from "./qiyuegl-5.vue?vue&type=script&setup=true&lang=js"

import "./qiyuegl-5.vue?vue&type=style&index=0&id=18785a86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18785a86"]])

export default __exports__